<template>
  <div id="steps" >
    <div class="step-container" v-for="(step, index) in dataSteps" v-bind:key="parseInt(step.tag_id)">
      <div class="step-counter"><span>{{step.tag_id}}</span></div>
      <a @click="$_slideAtIndex(step.tag_id)" class="step-title" v-html="step.title"></a>
      <div class="step-content" >
        <div v-html="step.content"></div>
        <div class="more-content" v-if="step.media">
        <button @click="$_revealMedia(step)" class="btn rounded grey lighten-4 z-depth-0 col waves-effect l3 s12 grey-text text-darken-2">
          <i class="material-icons grey-text darken-2 left">image</i> <i class="material-icons grey-text darken-2 right">expand_more</i>View more
        </button>
        <div class="clear"></div>
      </div>
      </div>
        <div ref="detailedMedia" v-bind:class="'media-0'+index" class="detailed-content" v-if="justClicked && justClicked.tag_id === step.tag_id">
          <div class="col s12" v-for="item in step.media" v-bind:key="item.id">
            <img class="materialboxed"  v-expandable="item" 
            :src="item.url" alt=""  
            v-if="item.type === 'image' && item.subtype ==='gif' ||
             item.type === 'image' && item.subtype ==='png' ||  
             item.type === 'image' && item.subtype ==='jpeg'"  width="100%">
             <video controls="" id="player"  v-if="item.mime_type == 'video/mp4'" :src="item.url"></video>
          </div>
          <div class="clear"></div>
        </div>
    </div>
    <div class="clear"></div>
    <br>
    <div
      style="clear:both; float:none; margin:auto; min-height:100px; width:100%"
    >

    </div>
  </div>  
</template>
<script>
import router from '@/router'
export default {
  name:'articleSteps',
  props:{
    dataSteps:{
      type:Array,
    }
  },
  data(){
    return {
      expendedOptions:[],
      justClicked:false,
    }
  },
  mounted(){
    
  },
  computed:{
    activeList:{
      get(){
        return this.expendedOptions.find(item=> item.tag_id === this.justClicked.tag_id) ? true : false
      },
      set(e){
        const record = this.expendedOptions.find(item=> item.tag_id === e.tag_id)
        record 
        ? false
        : this.expendedOptions.push(e)
      }
    }
  },
  beforeDestroy(){
   
  },
  methods:{
    $_revealMedia(item){
      if(item.tag_id === this.justClicked.tag_id){
      this.justClicked = false
      }else {
      this.justClicked = item
      this.activeList = item
      }

    },
    $_keyBoardNavigation(e){
        console.log(e.code)
    },
    $_slideAtIndex(index){
      router.push({query:{startIndex:parseInt(index - 1)}})
      this.$emit('action','open')
    }
  }
}
</script>
<style lang="scss" scoped>
#steps {
  .step-container {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  grid-gap: 2px;
  margin-bottom:24px;
    .step-counter {
      grid-column: 1 / 1;
      grid-row: 1;
      text-align: center;
      position: relative;
      line-height:24px;
      span {
          line-height: 31px;
          position: absolute;
          text-align: center;
          width: 100%;
          left: 0;
        @media screen and (max-width:680px) {
          font-size:13px;
          font-weight:600;
          line-height: 24px;
        }
      }
      &::before {
        position: absolute;
        content:' ';
        left:50%;
        transform: translateX(-50%);
        border-radius:50%;
        background: rgba(0,0,0,0.1);
        width:40px; 
        height:40px;
        top:-5px;
        @media screen and (max-width:680px) {
          width:26px;
          top:0px;
          height:26px;
        }
      }
    }
    .step-title{
      grid-column: 2 / 12;
      font-size:17.5px;
      font-weight:500;
      color:rgba(0,0,0,0.8);
      cursor:pointer;
      &::after{
        content: 'ondemand_video';
        font-family: 'Material Icons';
        font-size: 20px;
        margin-left: 5px;
        margin-top: -2px;
        position: absolute;
      }
    }
    .step-content {
      grid-column: 2 / 12 ;
    }
  }
  .detailed-content {
    padding:16px 0px;
    grid-column: 1 / 13;
    background: #efefef;
    border-radius: 4px;
    margin-top: 17px;
    video {
      width:100%;
    }
  }
}

</style>
<style lang="scss" >
 .step-content {
      p {
        margin:6px 0px;
        font-size:16px;
      }
      ol {
        li {
          font-size:16px;
          line-height: 1.6;
        }
      }
      ul {
        padding-left: 24px !important;
        li {
          list-style: disc;
          list-style-type: disc;
          font-size:16px;
          line-height: 1.6;
        }
      }
    }
</style>